import { ENDPOINT } from '../globals/endpoint';
import { apiHelper } from '../helpers/api-helper';
import { CreateApplicationReturn } from './create-application';

export const verifyOtp = async (otpCode: string): Promise<CreateApplicationReturn> => {
  const endpoint = ENDPOINT.VerifyOtp;

  const response = await apiHelper(endpoint, {
    method: 'POST',
    body: JSON.stringify({ otpCode }),
  });

  const resp = await response.json();

  return response.ok ? resp : void 0;
};
